import {
  FluxAboutDocument,
  CreateFluxAboutDocumentParams,
  UpdateFluxAboutDocumentParams,
} from 'types/Flux/About/fluxAboutDocument';
import getProductKey from 'helper/requests/getProductKey';
import baseApi, { GenericResponse } from './base';

function buildCreateFormData(params: CreateFluxAboutDocumentParams): FormData {
  const formData = new FormData();
  formData.append('titulo', params.titulo);
  formData.append('descricao', params.descricao);
  formData.append('autor', params.autor);
  formData.append('ordem', String(params.ordem));
  formData.append('pdf', params.pdf);
  return formData;
}

function buildUpdateFormData(
  params: Omit<UpdateFluxAboutDocumentParams, 'id'>,
): FormData {
  const formData = new FormData();
  if (params.titulo !== undefined) {
    formData.append('titulo', params.titulo);
  }
  if (params.descricao !== undefined) {
    formData.append('descricao', params.descricao);
  }
  if (params.autor !== undefined) {
    formData.append('autor', params.autor);
  }
  if (params.ordem !== undefined) {
    formData.append('ordem', String(params.ordem));
  }
  if (params.ativo !== undefined) {
    formData.append('ativo', String(params.ativo));
  }
  if (params.pdf) {
    formData.append('pdf', params.pdf);
  }
  return formData;
}

const PRODUCT_KEY_NAME = 'prevs-automatico';

const fluxAboutApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    listFluxAboutDocuments: build.query<FluxAboutDocument[], void>({
      query: () => {
        const productKey = getProductKey(PRODUCT_KEY_NAME);
        return {
          url: `produtos/flux/about/admin/list/?product_key=${productKey}`,
          method: 'GET',
        };
      },
      transformResponse: (
        response: GenericResponse<FluxAboutDocument[]>,
      ) => response.data,
      providesTags: ['FluxAboutDocument'],
    }),
    createFluxAboutDocument: build.mutation<
    GenericResponse<FluxAboutDocument>, CreateFluxAboutDocumentParams
    >({
      query: (params) => {
        const productKey = getProductKey(PRODUCT_KEY_NAME);
        return {
          url: `produtos/flux/about/admin/create/?product_key=${productKey}`,
          method: 'POST',
          body: buildCreateFormData(params),
        };
      },
      invalidatesTags: ['FluxAboutDocument'],
    }),
    updateFluxAboutDocument: build.mutation<
    GenericResponse<FluxAboutDocument>, UpdateFluxAboutDocumentParams
    >({
      query: ({ id, ...body }) => {
        const productKey = getProductKey(PRODUCT_KEY_NAME);
        return {
          url: `produtos/flux/about/admin/update/${id}/?product_key=${productKey}`,
          method: 'PUT',
          body: buildUpdateFormData(body),
        };
      },
      invalidatesTags: ['FluxAboutDocument'],
    }),
    deleteFluxAboutDocument: build.mutation<
    GenericResponse<null>, number
    >({
      query: (id) => {
        const productKey = getProductKey(PRODUCT_KEY_NAME);
        return {
          url: `produtos/flux/about/admin/delete/${id}/?product_key=${productKey}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['FluxAboutDocument'],
    }),
  }),
});

export const {
  useListFluxAboutDocumentsQuery,
  useCreateFluxAboutDocumentMutation,
  useUpdateFluxAboutDocumentMutation,
  useDeleteFluxAboutDocumentMutation,
} = fluxAboutApi;
